import { render, staticRenderFns } from "./nonthaburi-hub.vue?vue&type=template&id=44d43562&scoped=true"
import script from "./nonthaburi-hub.vue?vue&type=script&lang=js"
export * from "./nonthaburi-hub.vue?vue&type=script&lang=js"
import style0 from "./nonthaburi-hub.vue?vue&type=style&index=0&id=44d43562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d43562",
  null
  
)

export default component.exports